export interface SelectionState {
  selection: Array<string>;
  selectAll: boolean;
}

export const initialSelectionState: SelectionState = {
  selection: [],
  selectAll: false,
};
